import React from "react"
import RadioFilter from "./RadioFilter"

const CostFilter = ({ cost, onCostChange }) => {
  return <RadioFilter value={cost} onChange={onCostChange} />
}

export default CostFilter
